import React, { useEffect, useState } from 'react'
import Layout from '../Layout'
import { Row, Col, Button } from 'react-bootstrap'
import './newQr.css'
import CloseIcon from '@mui/icons-material/Close';
import Dummy from '../../../src/assets/images/dummy.png'
import { QrReader } from 'react-qr-reader';
import { AddQRCodes, fetchAllLocationByQRId, fetchCompaniesBySiteId, fetchLocationByQRCodeId, fetchSitesWithParentCompany } from '../../Redux/Api/fetch.api';
import errorIcon from "../../assets/images/error-icon.svg";
import { addQrCodes } from '../../Redux/Actions/QrCodeId';
import Modal from 'react-bootstrap/Modal';
import SiteCompanyQR from './SiteCompany';
import { useDispatch } from 'react-redux';
import { updateLocationByQRCode } from '../../Redux/Actions/QR';
import toast, { Toaster } from 'react-hot-toast';
import Loader from '../loader';
import { useLocation } from 'react-router';
import UploadMedia from './UploadMedia';
import { useTranslation } from "react-i18next";

const NewQR = () => {
    const { t } = useTranslation("dashboard");
    const dispatch = useDispatch();
    const [id, setId] = useState();
    const [newQR, setNewQR] = useState();
    const [qrcode, setqrcode] = useState();
    const [data, setData] = useState('No result');
    const [disable, setDisable] = useState(false);
    const [showScanner, setShowScanner] = useState(true);
    const [createModal, setCreateModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [qrcodeError, setQrcodeError] = useState(false);
    const [validqrError, setValidQrError] = useState(false);
    const [companyData, setCompanyData] = useState([]);
    const [locationIdByQRId, setLocationIdByQRId] = useState(1);
    const [isSiteCompanyShow, setIsSiteCompanyShow] = useState(false);
    const [isUploadPageShow, SetIsUploadPageShow] = useState(false);
    const [siteName, setSiteName] = useState('');
    //Error
    const [errorMessage, setErrorMessage] = useState("");

    const { state } = useLocation();
    const [isRedirected] = useState(state && state.isRedirected || false);

    const handleError = (err) => {
        setData({ result: "Device camera not found", qrError: err.toString() })
    }

    useEffect(() => {
        if (locationIdByQRId > 1) {
            SetIsUploadPageShow(true);
        }
    }, [locationIdByQRId]);
    const getCompaniesBySiteId = (comingid) => {
        if (comingid > 1) {
            fetchCompaniesBySiteId(comingid)
                .then(response => {
                    if (response.data.success) {
                        setCompanyData(response.data.data)
                    }
                })
                .catch((err) => {
                    console.log("Err: ", err);
                })
        }
    }
    const onResult = (result, error) => {
        if (result) {

            setData(result.text);
            var uri = result.text.toString();
            if (uri.indexOf("/") > 0) { // Example : https://www.tekahelp.com/10000004
                var qrCode = uri.substring(uri.lastIndexOf('/') + 1);
                console.log("uri", qrCode);
                if (qrCode) {
                    fetchLocationByQRCodeId(qrCode)
                        .then(response => {

                            if (response.data.success) {
                                getCompaniesBySiteId(response.data.data.siteId)
                                setLocationIdByQRId(response.data.data.siteId)
                                setSiteName(response.data.data.siteName);
                                setId(qrCode);
                                setShowScanner(false)
                                setIsSiteCompanyShow(true)

                            }
                            else {
                                setNewQR(qrCode)
                                setErrorMessage(t("QRCodeNotFound"));
                                setIsSiteCompanyShow(false)
                            }
                        })
                        .catch((err) => {
                            console.log("Err: ", err);
                            setErrorMessage(t("QRCodeNotValid"));
                            setIsSiteCompanyShow(false)
                        });
                }
                else {

                    setErrorMessage(t("QRCodeNotValid"));
                    setIsSiteCompanyShow(false)
                }
            }
            else {
                setErrorMessage(t("QRCodeNotValid"));
                setIsSiteCompanyShow(false)

            }
        }

    }

    const RedirecttoQREntries = () => {
        setCreateModal(true)
    }
    const handleCreateModalClose = () => {
        setCreateModal(false);
    };
    const addQRCode = () => {
        if (newQR || qrcode || id) {
            setLoading(true)
            AddQRCodes(newQR != undefined && newQR != "" ? newQR : qrcode)
                .then(response => {

                    dispatch(addQrCodes(response.data))
                    if (!response.data.success) // False 
                    {
                        toast.error(response.data.message, {
                            className: "toastSuccess",
                        });

                    }
                    else {
                        const newQRCodeValue = response.data.data;

                        // Make sure to set this!
                        setNewQR(newQRCodeValue);
                        setqrcode(newQRCodeValue);
                        toast.success(response.data.message, {
                            className: "toastSuccess",
                        })
                        setCreateModal(false)
                        setLocationIdByQRId(1)
                        setShowScanner(false)
                        setIsSiteCompanyShow(true)
                        setErrorMessage("")
                    }
                    setLoading(false)
                })
                .catch((err) => {
                    console.log("Err: ", err);
                });
            setLoading(false)
        }

    }

    const handleEnterManualQR = async () => {
        setDisable(true)
        if (qrcode) {

            fetchLocationByQRCodeId(qrcode)
                .then(response => {

                    if (response.data.success) {
                        setLocationIdByQRId(response.data.data.siteId)
                        setId(qrcode);
                        setShowScanner(false)
                        if (response.data.data.siteId > 1) {
                            getCompaniesBySiteId(response.data.data.siteId);
                            setSiteName(response.data.data.siteName);
                        }
                        setIsSiteCompanyShow(true)
                        setErrorMessage("")
                    }
                    else {
                        setValidQrError(true)
                        setIsSiteCompanyShow(false)
                    }
                    // setqrcode()
                })

                .catch((err) => {
                    console.log("Err: ", err);
                    setErrorMessage("QR Code is not valid, please try again.");
                });
        }

        else {
            setQrcodeError(true)
        }

    }

    return (
        <Layout isRedirected={isRedirected}>
            <div className='p-3 mx-auto'>
                <Toaster />
                {loading ? <Loader /> : ''}
                {!isSiteCompanyShow &&

                    <Row>
                        <Col lg={12} className="mx-auto">
                            {/* Screen 1 */}
                            <Row>
                                <Col lg={5} className="mx-auto">
                                    <section className='scan-code'>
                                        <h4 className='mb-3'>{t("ScanYourQRCode")}</h4>
                                        <div className="boxs">
                                            <div className='scan-box w-100' style={{ padding: "20px" }}>
                                                <QrReader
                                                    className="qr--scanner mt-0"
                                                    delay={300}
                                                    onError={handleError}
                                                    constraints={{ facingMode: 'environment' }}
                                                    style={{ width: '100%' }}
                                                    onResult={onResult}
                                                />

                                            </div>
                                            {newQR && errorMessage ? (
                                                <div className="d-flex justify-content-center">
                                                    <p className="text-danger validation-msgscan m-0">
                                                        {errorMessage}
                                                        <span><img src={errorIcon} alt="error icon" /></span>
                                                    </p>
                                                </div>
                                            ) : ""}
                                            {newQR && !isSiteCompanyShow ? <label class="form-label mb-0 d-inline-block w-100"><b>QR Code :</b>{newQR}</label> : ""}

                                            {newQR && errorMessage ?
                                                <button className="btn btn-bordered" onClick={() => RedirecttoQREntries()}>{t("CreateNewQR")}</button> : ""
                                            }
                                            <span>{t("OR")}</span>
                                            <div className='form-box w-100'>
                                                <div className="form-group">
                                                    <label>{t("EnterQRCode")} </label>
                                                    <div className="input-group">
                                                        <input name="qrcode" className="form-control" placeholder={t("EnterQRCode")}type="text" maxLength={10}
                                                            onChange={(e) => {
                                                                setDisable(false)
                                                                const newValue = e.target.value.replace(/[^0-9]/g, '');

                                                                setqrcode(newValue)

                                                                if (e.target.value == "Enter QRCode") {
                                                                    setQrcodeError(true)
                                                                }
                                                                else {
                                                                    setQrcodeError(false)
                                                                    setValidQrError(false)
                                                                }

                                                            }} value={qrcode} />

                                                    </div>
                                                    <div>

                                                        {qrcodeError ?
                                                            <p className="text-danger validation-msg d-block mt-2">{!qrcodeError ? ' ' : t("PleaseScanEnterQRCode")}
                                                                <span><img className="" src={errorIcon} ></img></span>
                                                            </p> : ""
                                                        }
                                                        {validqrError ?
                                                            < p className="text-danger validation-msg d-block mt-2">{validqrError ? t("QRCodeNotFoundTryAgain") : ' '}
                                                                <span><img className="" src={errorIcon} ></img></span>
                                                            </p>
                                                            : ""
                                                        }
                                                    </div>
                                                    {validqrError ?
                                                        <div>
                                                            <button className="btn btn-bordered new-qr-btn mb-2 " onClick={() => RedirecttoQREntries()}>{t("CreateNewQR")}</button>
                                                        </div> : ""
                                                    }

                                                    <button className="btn btn-primary" disabled={disable} onClick={(e) => handleEnterManualQR()} >{t("Next")}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </Col>
                            </Row>

                            <Modal
                                show={createModal}
                                onHide={handleCreateModalClose}
                                backdrop="static"
                                keyboard={false}
                                dialogClassName="modal-dialog-copy"
                            >
                                <Modal.Body>
                                    <div class="copy-model">
                                        <h5> {t("AreYouSureAddQR")}</h5>
                                        <div class="w-100 mt-3 btn-yesno">
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                                onClick={addQRCode}
                                            >
                                                {t("Yes")}
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-primary ml-2"
                                                onClick={handleCreateModalClose}
                                            >
                                                {t("No")}
                                            </button>
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>


                        </Col>
                    </Row>}

                {
                    locationIdByQRId > 1 && isUploadPageShow ? <UploadMedia
                        SiteName={siteName}
                        Id={id}
                        QRCode={qrcode}
                        NewQR={newQR}
                        SetIsUploadPageShow={SetIsUploadPageShow}
                        isUploadPageShow={isUploadPageShow}
                        setIsSiteCompanyShow={setIsSiteCompanyShow}
                        Data={data}
                        setNewQR={setNewQR}
                        setqrcode={setqrcode}
                        setValidQrError={setValidQrError}
                        setLocationIdByQRId={setLocationIdByQRId}
                        CurrentLocationId={locationIdByQRId}
                    />
                        :
                        isSiteCompanyShow && <div><SiteCompanyQR
                            locationIdByQRId={locationIdByQRId}
                            showScanner={showScanner}
                            newQR={newQR}
                            id={id}
                            qrcode={qrcode}
                            companyData={companyData}
                            setLocationIdByQRId={setLocationIdByQRId}
                            getCompaniesBySiteId={getCompaniesBySiteId}
                            setIsSiteCompanyShow={setIsSiteCompanyShow}
                            setNewQR={setNewQR}
                            setqrcode={setqrcode}
                            setValidQrError={setValidQrError}
                            data={data}
                        /></div>

                }
            </div >

        </Layout >
    )
}


export default NewQR
